import React from 'react';
import { IContentLink } from '../Models';

interface IContentLinkProps {
    breadCrumb: IContentLink[];
    description: string;
    title: string;
    url: string;
}

export function ContentLink(content: IContentLinkProps) {
    // handle link from different area
    // link are: /language/area/category1/category2/page
    const pathCurrent = document.location.pathname.split('/');
    const pathContent = content.url.split('/');
    let isExternal = false;
    if (pathCurrent.length > 1 && pathContent.length > 1) {
        // if link start with a '/' area is suppose to be at index [2]
        isExternal =
            pathCurrent[2].toUpperCase() != pathContent[2].toUpperCase();
    }

    return (
        <article className="tile">
            {content.breadCrumb.length > 0 && (
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {content.breadCrumb.map((ele, i) => (
                            <li key={i} className="breadcrumb-item">
                                <a href={ele.url}>{ele.name}</a>
                            </li>
                        ))}
                    </ol>
                </nav>
            )}
            <a
                href={content.url}
                target={isExternal ? '_blank' : '_self'}
                rel={isExternal ? 'noopener noreferrer' : undefined}
            >
                <h4
                    className={
                        'secondary-text-color' + (isExternal ? ' external' : '')
                    }
                >
                    {content.title}
                </h4>
            </a>
            <p className="description">{content.description}</p>
        </article>
    );
}
